import type { RoadKit } from "../kit/types";

/**
 * Runestone Way (MP-23, the Trophy Hall: 900 Trophies; contract tools/art/skins/README.md §Roads). Dark basalt
 * hexagonal setts whose joints wake one by one in a faint sea-green (the ground shader's paving, render/groundPave.ts)
 * between rough granite kerbs held by iron straps, dressed from `art/hq/skins/runestone/kit.glb`
 * (tools/art/skins/roads_trophy.py): a sunken slab of three carved runes every other cell, standing stones whose column
 * of runes has light flowing up it with a rune glyph turning over each, and little cairns. The runes breathe slowly down
 * the road at rest and FLARE as the enemies cross them, fading behind (RoadPiece.react: one float per instance, set
 * from the enemies' positions each frame by kit/roadDecor.ts).
 */
export const RUNESTONE: RoadKit = {
  id: "road.runestone",
  tint: [0.5, 0.55, 0.68],
  asset: "skins/runestone/kit",
  surface: {
    pattern: "hex", scale: 2.6, jointWidth: 0.07, grain: 0.75, bevel: 0.8,
    stone: [0.075, 0.08, 0.095], stone2: [0.14, 0.15, 0.17], joint: [0.02, 0.04, 0.04],
    glow: { colour: [0.1, 0.7, 0.55], base: 0, pulse: 0.5, hz: 0.12, waveK: 0.25, sharp: 8 },
  },
  pieces: [
    { piece: "kerb", every: 1, place: "centre", on: "straight" },
    { piece: "kerbturn", every: 1, place: "centre", on: "turn" },
    { piece: "runes", every: 2, place: "centre", on: "straight", motion: { glow: 0.55, hz: 0.18, travel: 0.6 }, react: { glow: 3, radius: 0.9, fade: 1.2 } },
    { piece: "menhir", every: 5, phase: 2, place: "verge", side: 0.6, on: "straight",
      motion: { glow: 0.3, hz: 0.22, flow: { speed: 0.12, length: 0.25, glow: 1.2 } }, react: { glow: 2, radius: 1.3, fade: 1.5 } },
    { piece: "glyph", every: 5, phase: 2, place: "verge", side: 0.6, on: "straight", lift: 0.78, motion: { spin: 0.7, bob: 0.04, hz: 0.35, glow: 0.4 } },
    { piece: "cairn", every: 5, phase: 4, place: "verge", side: 0.55, on: "straight", motion: { glow: 0.4, hz: 0.27 } },
  ],
};
